import { useEffect } from "react";
import { notifications } from "@mantine/notifications";

export const useSuccessToast = (
  message: string | null,
  title: string,
  onConsumed?: () => void,
): void => {
  useEffect(() => {
    if (!message) return;
    notifications.show({
      color: "green",
      title,
      message,
      withCloseButton: true,
      autoClose: 4000,
    });
    onConsumed?.();
  }, [message, title, onConsumed]);
};
